import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ReadByModelCache3hp3dxfu3dctp as ReadByModelCache } from '../../sdk/ReadByModelCache.mjs';
import { ModelCache1j2q0r8bmhrox as ModelCache } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ModelCache.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { createReorderModssndd63zi2ijm as createReorderMods } from '../../../../../crowpay-shared/com/crowpay/Reorderable.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DragDropReordering2of2svhx5wqie as DragDropReordering,
  HalfGap_getInstance2pfkgmm8af0gl as HalfGap_getInstance,
  Delegate2igvowszj3trz as Delegate,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { IndexedValue22atz80p92rrf as IndexedValue } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/IndexedValue.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  divkhq3vjih9fcw as div,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  forEach37zw770vd3h4l as forEach,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_serializer(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ModelCache()) {
    tmp = _this__u8e3s4.udv_1;
  } else {
    if (_this__u8e3s4 instanceof ReadByModelCache()) {
      tmp = _this__u8e3s4.df9_1.udv_1;
    } else {
      throw UnsupportedOperationException().i5('Unsupported ModelCacheLike type ' + toString(_this__u8e3s4));
    }
  }
  return tmp;
}
function *_generator_reorder__gk1py1(_this__u8e3s4, items, cache, $completion) {
  if (items.p1() <= 1)
    return Unit_instance;
  if (_this__u8e3s4.edl_1 === _this__u8e3s4.fdl_1)
    return Unit_instance;
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = createReorderMods(items, get_serializer(cache), _this__u8e3s4.edl_1, _this__u8e3s4.fdl_1).d2().m1();
  while (_iterator__ex2g4s.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.component1' call
    var id = _destruct__k2r9zo.e2();
    // Inline function 'kotlin.collections.component2' call
    var mod = _destruct__k2r9zo.f2();
    var tmp = cache.geo(id).nen(mod, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function reorder(_this__u8e3s4, items, cache, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_reorder__gk1py1.bind(VOID, _this__u8e3s4, items, cache), $completion);
}
function forEachMaybeReorderable(_this__u8e3s4, items, groupId, reorder, allowReorder, separator, render) {
  allowReorder = allowReorder === VOID ? true : allowReorder;
  var tmp;
  if (separator === VOID) {
    tmp = forEachMaybeReorderable$lambda;
  } else {
    tmp = separator;
  }
  separator = tmp;
  var handler = new (DragDropReordering())(_this__u8e3s4, 'application/kiteui-index;id=' + groupId, reorder);
  var oldGap = _this__u8e3s4.db9();
  _this__u8e3s4.bb9(get_px(0));
  var tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = $this$remember.daj(items);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var idx = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$0 = new (IndexedValue())(idx, item);
      destination.v(tmp$ret$0);
    }
    return destination;
  });
  forEachUpdating(_this__u8e3s4, tmp_0, VOID, ($this$forEachUpdating, indexed) => {
    var item = lens(indexed, forEachMaybeReorderable$lambda$lambda);
    var idx = lens(indexed, forEachMaybeReorderable$lambda$lambda_0);
    var tmp;
    if (allowReorder) {
      tmp = lens(idx, DragDropReordering$encode$ref(handler));
    } else {
      tmp = null;
    }
    var data = tmp;
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.gbb(p, view);
    view.zbm(true);
    view.kba(true);
    var tmp_0 = oldGap;
    if (!((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null)) {
      view.bb9(div(oldGap, 2));
    } else {
      view.lba(view.qb6_1.abf(HalfGap_getInstance()));
    }
    if (allowReorder) {
      view.kb9(new (Delegate())(handler, idx));
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    if (allowReorder) {
      view_0.lbb(shownWhen(view_0, VOID, ($this$shownWhen) => {
        var tmp0_elvis_lhs = $this$shownWhen.daj(handler.bdl_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var move = tmp;
        var idx_0 = $this$shownWhen.daj(idx);
        return move.fdl_1 === idx_0 && move.edl_1 >= idx_0;
      }), separator(view_0, item));
    }
    view.hbb(p_0, view_0);
    render(view, item, data);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    if (allowReorder) {
      view_1.lbb(shownWhen(view_1, VOID, ($this$shownWhen) => {
        var tmp0_elvis_lhs = $this$shownWhen.daj(handler.bdl_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var move = tmp;
        var idx_0 = $this$shownWhen.daj(idx);
        return move.fdl_1 === idx_0 && move.edl_1 < idx_0;
      }), separator(view_1, item));
    }
    view.hbb(p_1, view_1);
    $this$forEachUpdating.hbb(p, view);
    return Unit_instance;
  });
}
function forEachMaybeReorderableDestroying(_this__u8e3s4, items, groupId, reorder, allowReorder, separator, render) {
  allowReorder = allowReorder === VOID ? true : allowReorder;
  var tmp;
  if (separator === VOID) {
    tmp = forEachMaybeReorderableDestroying$lambda;
  } else {
    tmp = separator;
  }
  separator = tmp;
  var handler = new (DragDropReordering())(_this__u8e3s4, 'application/kiteui-index;id=' + groupId, reorder);
  var oldGap = _this__u8e3s4.db9();
  _this__u8e3s4.bb9(get_px(0));
  var tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = $this$remember.daj(items);
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var idx = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$0 = new (IndexedValue())(idx, item);
      destination.v(tmp$ret$0);
    }
    return destination;
  });
  forEach(_this__u8e3s4, tmp_0, ($this$forEach, _destruct__k2r9zo) => {
    var idx = _destruct__k2r9zo.cf();
    var item = _destruct__k2r9zo.df();
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEach.pc());
    var tmp0_elvis_lhs = $this$forEach.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEach : tmp0_elvis_lhs;
    $this$forEach.gbb(p, view);
    view.zbm(true);
    view.kba(true);
    var tmp = oldGap;
    if (!((tmp == null ? null : new (Dimension())(tmp)) == null)) {
      view.bb9(div(oldGap, 2));
    } else {
      view.lba(view.qb6_1.abf(HalfGap_getInstance()));
    }
    if (allowReorder) {
      view.kb9(new (Delegate())(handler, new (Constant())(_Constant___init__impl__v45mub(idx))));
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    if (allowReorder) {
      view_0.lbb(shownWhen(view_0, VOID, ($this$shownWhen) => {
        var tmp0_elvis_lhs = $this$shownWhen.daj(handler.bdl_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var move = tmp;
        return move.fdl_1 === idx && move.edl_1 >= idx;
      }), separator(view_0, item));
    }
    view.hbb(p_0, view_0);
    render(view, item, handler.hdl(idx));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    if (allowReorder) {
      view_1.lbb(shownWhen(view_1, VOID, ($this$shownWhen) => {
        var tmp0_elvis_lhs = $this$shownWhen.daj(handler.bdl_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var move = tmp;
        return move.fdl_1 === idx && move.edl_1 < idx;
      }), separator(view_1, item));
    }
    view.hbb(p_1, view_1);
    $this$forEach.hbb(p, view);
    return Unit_instance;
  });
}
function forEachMaybeReorderable$lambda(_this__u8e3s4, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Separator())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function forEachMaybeReorderable$lambda$lambda(it) {
  return it.ml_1;
}
function forEachMaybeReorderable$lambda$lambda_0(it) {
  return it.ll_1;
}
function DragDropReordering$encode$ref(p0) {
  var l = (_this__u8e3s4) => p0.hdl(_this__u8e3s4);
  l.callableName = 'encode';
  return l;
}
function forEachMaybeReorderableDestroying$lambda(_this__u8e3s4, it) {
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Separator())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  _this__u8e3s4.hbb(p, view);
  return view;
}
//region block: exports
export {
  forEachMaybeReorderableDestroying as forEachMaybeReorderableDestroying35lnn8f9ey87k,
  forEachMaybeReorderable as forEachMaybeReorderable1aeoqjpfy2fje,
  reorder as reorderts8zja415q79,
};
//endregion

//# sourceMappingURL=reordering.mjs.map
